import { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setImg, setName, logout } from '../store/reducers/user.js'
import { setUpperPopup } from '../store/reducers/general.js'
import { userService } from '../services/user.js'
import { uploadFile } from "../services/upload.js"
import { Loader } from '../cmps/loader.jsx'
import { Login } from './login.jsx'

export function Profile() {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const [loader, setLoader] = useState(false)
    const [editIcon, setEditIcon] = useState(false)
    const [editName, setEditName] = useState(false)
    const name = useRef()

    useEffect(() => {
        if (name.current) {
            name.current.value = user.name
            name.current.focus()
        }
    }, [editName])

    const onNameChange = async (ev) => {
        ev.preventDefault()
        try {
            const newName = name.current.value
            if (!newName || newName === user.name) return
            if (newName.length > 20 || newName.length < 2) return dispatch(setUpperPopup('errorName'))
            await userService.editUser({ name: newName })
            dispatch(setName(newName))
            dispatch(setUpperPopup('channelEdited'))
            setEditName(false)
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const onImageChange = async (ev) => {
        try {
            setLoader(true)
            if (!ev.target.files[0]) return setLoader(false)
            if (!ev.target.files[0].type.startsWith('image/')) {
                setLoader(false)
                dispatch(setUpperPopup('image-only'))
                return
            }
            const { secure_url } = await uploadFile(ev.target.files[0])
            await userService.editUser({ img: secure_url })
            dispatch(setImg(secure_url))
            setLoader(false)
        }
        catch (err) {
            dispatch(setUpperPopup('errorServer'))
            setLoader(false)
        }
    }

    if (!user._id) return <Login />

    return <div className='profile profile-details'>
        <div className='channel'>
            <div className='img-wrapper'>
                {loader ? <Loader /> : <>
                    <input type="file" className="non-appear" accept="image/*" id='image-field' onChange={onImageChange} />
                    <label htmlFor='image-field'>
                        <img onMouseEnter={() => setEditIcon(true)} onMouseLeave={() => setEditIcon(false)} src={user.img} alt='channel' />
                        {editIcon && <span className="edit-icon material-symbols-outlined" onMouseEnter={() => setEditIcon(true)} onMouseLeave={() => setEditIcon(false)}>add_a_photo</span>}
                    </label>
                </>}
            </div>
            <div className='name-wrapper'>
                <div className='edit-button'><span className="material-symbols-outlined" onClick={() => setEditName(!editName)}>{editName ? 'close' : 'edit'}</span></div>
                {editName ? <form onSubmit={onNameChange} className='edit-name'>
                    <input className='channel-name border' maxLength={20} ref={name} />
                    <button className='edit-button'><span className="material-symbols-outlined">check</span></button>
                </form> :
                    <p className='channel-name'>{user.name}</p>}
            </div>
        </div>
        <p className='email noselect'>האימייל שלך : {user.email} <span className="material-symbols-outlined" onClick={() => { navigator.clipboard.writeText(user.email); dispatch(setUpperPopup('copied')) }}>content_copy</span></p>
        <div className="vertical-rest-end">
            <div className='red-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', cursor: 'pointer', paddingBottom: '80px' }} onClick={() => dispatch(logout())} >
                <span className="material-symbols-outlined">logout</span>
                <p>התנתק</p>
            </div>
        </div>
    </div>
}